/**
 * Strip the `*word*` emphasis marker used in titles/decks (see `Emphasis.tsx`)
 * down to plain text, for contexts that can't render JSX: meta tags, JSON-LD,
 * `document.title`.
 */
export function stripEmphasis(text: string): string {
  return text.replace(/\*([^*]+)\*/g, '$1');
}

/** Format an ISO `YYYY-MM-DD` date as e.g. "Jun 3, 2026" (UTC, no TZ drift). */
export function formatDate(iso: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  const [y, m, day] = iso.split('-').map(Number);
  const d = new Date(Date.UTC(y, m - 1, day));
  // Reject logically impossible dates (e.g. Feb 31) that Date silently rolls over.
  if (d.getUTCFullYear() !== y || d.getUTCMonth() !== m - 1 || d.getUTCDate() !== day) {
    return iso;
  }
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
